import React, { MouseEvent } from 'react';

import { IComponent } from '../../../typings/generic-component';
import { getUrlStatic } from '../../../utils/placeholders-football';
import { makeClassNames } from '../../../utils/styles';
import { ITeam, Winner } from '../../molecules/competition-board-card/competition-board-card';
import ImgPlaceholder from '../img-placeholder/img-placeholder';
import './competition-board-card-preview.scss';

const placeholder = `https://${getUrlStatic()}/images/skysport/configurations/placeholders/football/team-logo.png`;
export interface ICompetitionBoardCardPreview extends IComponent {
  onClick?: (e?: MouseEvent) => void;
  home?: ITeam;
  away?: ITeam;
  winner?: Winner;
}

const classNames = () =>
  makeClassNames({
    competitionBoardCardPreview: 'competition-board-card-preview',
    image: 'competition-board-card-preview__image',
    loserImage: 'competition-board-card-preview__image competition-board-card-preview__image--loser',
  });

const CompetitionBoardCardPreview = ({ home, away, onClick, winner }: ICompetitionBoardCardPreview) => {
  const cn = classNames();

  return (
    <div tabIndex={0} onClick={onClick} className={cn.competitionBoardCardPreview}>
      <div className={winner === 'away' ? cn.loserImage : cn.image}>
        <ImgPlaceholder title={home?.name || ''} src={home?.image || undefined} placeholder={placeholder} />
      </div>
      <div className={winner === 'home' ? cn.loserImage : cn.image}>
        <ImgPlaceholder title={away?.name || ''} src={away?.image || undefined} placeholder={placeholder} />
      </div>
    </div>
  );
};

export default CompetitionBoardCardPreview;
